import React, { useState } from 'react';
import { Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCube, faExternalLinkAlt, faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import NftViewerModal from './NftViewerModal';

/**
 * NftPlatformAppCard
 * Platform App Card for listing and viewing owned Health Diagram NFTs (Ethereum & Sui)
 * available by default in the Beer search and Favourites pages for PCD users.
 */
const NftPlatformAppCard = ({ isPcdUser = true }) => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <div
        className="beer-item col-12 col-sm-6 col-md-4 p-3 text-center"
        onClick={() => setModalOpen(true)}
        style={{ cursor: 'pointer' }}
        data-testid="nft-platform-app-card"
      >
        <div className="details bg-white p-3 h-100 rounded-3 shadow-sm border border-warning position-relative d-flex flex-column justify-content-between">
          <div>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <Badge bg="warning" text="dark" className="fw-bold px-2 py-1">
                Platform App · PRO
              </Badge>
              <Badge bg="dark" className="small">
                MetaMask Web3
              </Badge>
            </div>

            <div className="my-3 py-2 bg-light rounded-3 d-flex align-items-center justify-content-center flex-column" style={{ height: '140px' }}>
              <div className="text-warning mb-2" style={{ fontSize: '2.5rem' }}>
                <FontAwesomeIcon icon={faCube} />
              </div>
              <div className="d-flex gap-2">
                <Badge bg="primary" style={{ fontSize: '0.7rem' }}>Ethereum</Badge>
                <Badge bg="info" className="text-white" style={{ fontSize: '0.7rem' }}>Sui Network</Badge>
              </div>
            </div>

            <h5 className="text-warning font-weight-bold mb-1">Health Diagram NFTs</h5>
            <p className="text-muted small mb-2">
              Owned on-chain health diagrams (Sleep, Activity, Readiness) minted via HealthSync Pro and HealthyMe Pro flavours.
            </p>
          </div>

          <div className="pt-2 border-top mt-2">
            <button
              className="btn btn-outline-warning btn-sm w-100 fw-bold d-flex align-items-center justify-content-center gap-1"
              onClick={(e) => {
                e.stopPropagation();
                setModalOpen(true);
              }}
            >
              <FontAwesomeIcon icon={faExternalLinkAlt} className="small" />
              <span>Connect Wallet & View NFTs</span>
            </button>
            <div className="text-muted mt-1" style={{ fontSize: '0.68rem' }}>
              <FontAwesomeIcon icon={faShieldAlt} className="me-1 text-success" />
              ERC-721 & Sui Move Compatible
            </div>
          </div>
        </div>
      </div>

      <NftViewerModal
        show={modalOpen}
        onHide={() => setModalOpen(false)}
        isPcdUser={isPcdUser}
      />
    </>
  );
};

export default NftPlatformAppCard;

